import React, { useEffect, useState } from 'react'
import {
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from '@coreui/react-pro'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { GripVertical } from 'lucide-react'

import ToastComponent from 'src/components/common/TaostComponent.js'
import TeamPlayerService from 'src/service/TeamPlayerService'

const SquadPickedTable = ({ pickedPlayer, fixtureId = 0, teamId = 0 }) => {
  const [players, setPlayers] = useState([])
  useEffect(() => {
    if (pickedPlayer) {
      setPlayers(pickedPlayer)
    }
  }, [pickedPlayer])

  // Reorder function
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list)
    const [removed] = result.splice(startIndex, 1)
    result.splice(endIndex, 0, removed)
    return result
  }

  // Save order to backend
  const savePlayerOrder = async (updatedList) => {
    const payload = {
      fixtureId,
      teamId,
      playerOrder: updatedList.map((p, index) => ({
        id: p.id,
        orderno: index + 1,
      })),
    }

    try {
      const res = await TeamPlayerService.savePlayerOrder(payload)
      if (res.status === 200) {
        ToastComponent('Player order saved successfully', 'success')
      }
    } catch (err) {
      ToastComponent('Unable to save order', 'error')
    }
  }

  // On drag end
  const onDragEnd = (result) => {
    if (!result.destination) return

    const updatedOrder = reorder(players, result.source.index, result.destination.index)
    setPlayers(updatedOrder)

    savePlayerOrder(updatedOrder)
  }

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="playersTable">
        {(provided) => (
          <CTable striped responsive {...provided.droppableProps} ref={provided.innerRef}>
            <CTableHead>
              <CTableRow>
                <CTableHeaderCell>Order</CTableHeaderCell>

                <CTableHeaderCell scope="col">Player Name</CTableHeaderCell>
              </CTableRow>
            </CTableHead>

            <CTableBody>
              {players.map((player, index) => (
                <Draggable key={player.id} draggableId={player.id.toString()} index={index}>
                  {(providedDrag) => (
                    <CTableRow
                      ref={providedDrag.innerRef}
                      {...providedDrag.draggableProps}
                      {...providedDrag.dragHandleProps}
                      style={{
                        ...providedDrag.draggableProps.style,
                        cursor: 'grab',
                      }}
                    >
                      <CTableDataCell style={{ width: '40px' }}>
                        <GripVertical size={18} /> {/* Drag icon */}
                      </CTableDataCell>
                      <CTableHeaderCell>{player.player_name}</CTableHeaderCell>
                    </CTableRow>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </CTableBody>
          </CTable>
        )}
      </Droppable>
    </DragDropContext>
  )
}

export default SquadPickedTable
